<template>
  <div class="astiiss">
    <div>
      <ul class="ulstyle">
        <li @click="sort()" style="cursor: pointer">
          检测时间
          <span class="el-icon-d-caret"></span>
        </li>
        <li>检测类别</li>
        <li>检测结果值</li>
      </ul>
    </div>
    <div>
      <table cellspacing="0">
        <tr v-for="(items,index) in Takt.slice((currentPage-1)*pagesize,currentPage*pagesize)" :key="items.createdAt + index">
          <td>{{moment(items.createdAt,'YYYY-MM-DD hh:mm:ss')}}</td>
          <td>{{items.lefttag===undefined? items.right_vision : items.left_vision }}</td>
          <td>{{items.righttag===undefined? items.lefttag : items.righttag}}</td>
        </tr>
        <tr class="data" v-if="isData">暂无数据</tr>
      </table>
      <div class="pagination" v-if="isif">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="Takt.length"
          background
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import cookie from "js-cookie";
import moment from "moment";
export default {
  data() {
    return {
      Takt: [],
      currentPage: 1,
      pagesize: 10,
      isif: false,
      isData: false
    };
  },
  created() {
    let id = localStorage.getItem("id");
    axios
      .get("/report/patient/" + id, { headers: this.authHeader() })
      .then(res => {
        if (res.data.content.length == 0) {
          this.isif = false;
          this.isData = true;
        } else {
          this.isif = true;
          this.isData = false;
        }
        res.data.content.forEach(item => {
          this.Takt.push({
            createdAt: item.createdAt,
            lefttag: item.content.report_test.vision_test_2m.result.left_vision,
            righttag:
              item.content.report_test.vision_test_2m.result.right_vision,
            left_vision: "(视力)左眼",
            right_vision: "(视力)右眼"
          });
        });
      });
  },
  methods: {
    authHeader() {
      return {
        "x-auth-token": localStorage.getItem("token")
      };
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    //排序
    sort() {
      return this.Takt.reverse();
    }
  }
};
</script>

<style lang="scss">
.astiiss {
  width: 100%;
  height: 54px;
  background: #fafafa;
  border-radius: 3px 3px 0px 0px;
  margin: 10px 0;

  .ulstyle {
    margin: 35px 0 0 0;
    width: 100%;
    display: flex;
  }
  .ulstyle li {
    flex: 1;
    list-style: none;
    float: left;
    text-align: center;
    height: 50px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 50px;
  }
  .ulstyle li:nth-child(1) {
    text-align: left;
    text-indent: 25px;
    user-select: none;
  }
  table {
    width: 100%;
    text-align: left;
    padding: 0px 1px;
  }
  table tr {
    width: 100%;
    display: flex;
    border-bottom: 1px solid #f2f6fb;
  }
  td {
    flex: 1;
    height: 60px;
    color: #515151;
    width: 25%;
    text-align: center;
    line-height: 60px;
  }
  td:nth-child(1) {
    text-align: left;
    text-indent: 23px;
  }
  .pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .el-icon-d-caret {
    margin-left: -26px;
  }
  .data {
    display: flex;
    justify-content: center;
    font-size: 15px;
    margin: 40px 0;
    color: rgba(0, 0, 0, 0.65);
    border-bottom: none;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/acount/astiiss.vue